module.exports = __webpack_public_path__ + "img/quickshape-en.b90feea.jpg";